import React from 'react';
import cn from 'classnames';
import styles from './ChartButton.scss';

interface IProps {
  isActive: boolean,
  disabled: boolean,
  onClick: () => void,
  value: string,
  className?: string,
  dataTest?: string,
}

const ChartButton = (props: IProps) => {
  const stylesClass = cn(styles.btn, {
    [styles.btnActive]: props.isActive,
    [styles.btnDisabled]: props.disabled,
  }, props.className);
  const dataTest = props.dataTest || 'marketChartButton';

  return (
    <button
      type="button"
      className={ stylesClass }
      onClick={ props.onClick }
      disabled={ props.disabled }
      data-test={ dataTest }
    >
      { props.value }
    </button>
  );
};

export default ChartButton;
